import axiosClient from './axiosClient';

export const saveVersionApi = (data: any) => {
    const url = `${process.env.REACT_APP_PUBLIC_URL}/documents/api/quotes-document/version`
   return axiosClient.post(url, data)
};

export const saveMultipleVersionApi = (data: any) => {
    const url = `${process.env.REACT_APP_PUBLIC_URL}/documents/api/quotes-document/versions`
   return axiosClient.post(url, data)
};
